"use strict";

exports.actions = void 0;
var _intl = require("@formatjs/intl");
var actions = exports.actions = (0, _intl.defineMessages)({
  backToHomePage: {
    id: 'actions.backToHomepage',
    defaultMessage: 'Back to homepage'
  },
  copyShareUrl: {
    id: 'actions.copyShareUrl',
    defaultMessage: 'Copy URL'
  },
  download: {
    id: 'actions.download',
    defaultMessage: 'Download'
  },
  loadMore: {
    id: 'actions.loadMore',
    defaultMessage: 'Load more'
  },
  more: {
    id: 'actions.more',
    defaultMessage: 'More'
  },
  privacyRequests: {
    id: 'actions.privacyRequests',
    defaultMessage: 'Privacy requests'
  },
  readMore: {
    id: 'actions.readMore',
    defaultMessage: 'Read more'
  },
  reload: {
    id: 'actions.reload',
    defaultMessage: 'Reload'
  },
  share: {
    id: 'actions.share',
    defaultMessage: 'Share:'
  },
  startUsingCookies: {
    id: 'actions.startUsingCookies',
    defaultMessage: 'Start using cookies'
  },
  stopUsingCookies: {
    id: 'actions.stopUsingCookies',
    defaultMessage: 'Stop using cookies'
  },
  subscribe: {
    id: 'actions.subscribe',
    defaultMessage: 'Subscribe'
  },
  unsubscribe: {
    id: 'actions.unsubscribe',
    defaultMessage: 'Unsubscribe'
  },
  toggleFilters: {
    id: 'actions.toggleFilters',
    defaultMessage: 'Toggle search filters'
  }
});